import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function onlyNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const {value} = control;
    if(!value) { return null }
    const isValid = /^([1-9][0-9]*|0)(\.[0-9]+)?$/.test((`${value}` || '').trim());
    return isValid ? null : {valid: false};
  }
}
